(function(){
  var toggle = document.getElementById('navToggle');
  var menu = document.getElementById('navMobileMenu');
  if(toggle && menu){
    toggle.addEventListener('click', function(){
      var open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
    menu.querySelectorAll('a').forEach(function(a){
      a.addEventListener('click', function(){ menu.classList.remove('is-open'); });
    });
  }
  // Close on outside click
  document.addEventListener('click', function(e){
    if(menu && toggle && !menu.contains(e.target) && !toggle.contains(e.target)){
      menu.classList.remove('is-open');
    }
  });
})();